export const notificationQueryKeys = {
    all: (accountId: number) => ['notifications', accountId],
    notification: (accountId: number, notificationId: number) => [
        ...notificationQueryKeys.all(accountId),
        notificationId,
    ],
};
